import {
  FETCH_FAQ,
  FETCH_FAQ_FAILURE,
  FETCH_FAQ_SUCCESS,
  RESET_STATE,
  SET_SELECTED_LETTER,
  SET_TARGET_TERM_ID,
  SET_VIDEO_MODAL_DATA,
  SET_VIDEO_REMAINING_DURATION,
  UPDATE_SELECTED_CATEGORY,
  UPDATE_SELECTED_QUESTION,
  UPDATE_STEP,
} from './constants';

export function fetchFaq(loanNumber) {
  return {
    payload: { loanNumber },
    type: FETCH_FAQ,
  };
}

export function fetchFaqFailure(error) {
  return {
    payload: { error },
    type: FETCH_FAQ_FAILURE,
  };
}
export function fetchFaqSuccess(faqCategories) {
  return {
    payload: { faqCategories },
    type: FETCH_FAQ_SUCCESS,
  };
}

export function resetState() {
  return { type: RESET_STATE };
}

export function setSelectedLetter(letter) {
  return {
    payload: { letter },
    type: SET_SELECTED_LETTER,
  };
}

export function setTargetTermId(id) {
  return {
    payload: { id },
    type: SET_TARGET_TERM_ID,
  };
}

export function setVideoModalData(data) {
  return {
    payload: { data },
    type: SET_VIDEO_MODAL_DATA,
  };
}

export function setVideoRemainingDuration(value) {
  return {
    payload: { value },
    type: SET_VIDEO_REMAINING_DURATION,
  };
}

export function updateSelectedCategory(id) {
  return {
    payload: { id },
    type: UPDATE_SELECTED_CATEGORY,
  };
}

export function updateSelectedQuestion(id) {
  return {
    payload: { id },
    type: UPDATE_SELECTED_QUESTION,
  };
}

export function updateStep(step) {
  return {
    payload: { step },
    type: UPDATE_STEP,
  };
}
